import React, { useEffect, useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  getDoc,
  updateDoc
} from 'firebase/firestore';
import emailjs from 'emailjs-com';

const Approved = () => {
  const [approvedClaims, setApprovedClaims] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'claims'), where('status', '==', 'approved'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const filtered = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(claim => !claim.notified); // ✅ Only show un-notified claims
      setApprovedClaims(filtered);
    });

    return () => unsubscribe();
  }, []);

  const sendEmailNotification = async (claim) => {
    const now = new Date();
    const userName = claim.claimedByName || claim.yourName || 'User';
    const itemName = claim.itemName || 'Unnamed Item';
    const recipientEmail =
      claim.studentEmail || claim.email || claim.userEmail || '';

    if (!recipientEmail) {
      console.warn('⚠️ No email found for claim:', claim);
      alert('No email address available for this user.');
      return;
    }

    // ✅ Fetch item data from lostItems collection
    let foundLocation = 'Unavailable';
    let dateLost = 'Unavailable';
    let extraMessage = 'No additional info';

    if (claim.itemId) {
      try {
        const itemDoc = await getDoc(doc(db, 'lostItems', claim.itemId));
        if (itemDoc.exists()) {
          const itemData = itemDoc.data();
          foundLocation = itemData.location?.trim() || foundLocation;
          dateLost = itemData.dateLost?.toDate().toLocaleDateString() || dateLost;
          extraMessage = itemData.message?.trim() || extraMessage;
        }
      } catch (error) {
        console.warn('⚠️ Could not fetch item data:', error);
      }
    }

    const formattedDateTime = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }).format(now);

    const messageBody = `
Dear ${userName},

Your item claim has been APPROVED on ${formattedDateTime}.
Please collect it from the IT office.

Item Details:
• Item Name: ${itemName}
• Found Location: ${foundLocation}
• Reported On: ${dateLost}
• Additional Info: ${extraMessage}

Thank you,
USIU Asset Recovery Team
    `;

    const templateParams = {
      title: 'Claim Approved',
      to_name: userName,
      name: userName,
      email: recipientEmail,
      to_email: recipientEmail,
      message: messageBody
    };

    emailjs.send(
      'service_uqhmv2d',
      'template_ysvizk5',
      templateParams,
      'TXMLkK7adMZgLUrgF'
    ).then(() => {
      alert(`📩 Email sent to ${userName} at ${recipientEmail}`);
    }).catch((error) => {
      console.error('Email sending error:', error);
      alert('❌ Failed to send email.');
    });
  };

  const handleNotify = async (claim) => {
    try {
      await sendEmailNotification(claim);
      const claimRef = doc(db, 'claims', claim.id);
      await updateDoc(claimRef, {
        notified: true,
      });

      alert(`✅ Marked as notified: ${claim.claimedByName || claim.yourName}`);
    } catch (error) {
      console.error('❌ Error notifying owner:', error);
      alert('Failed to send notification.');
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>✅ Approved Claims</h2>
      {approvedClaims.length === 0 ? (
        <p>No approved claims found.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {approvedClaims.map(claim => (
            <li key={claim.id} style={{
              backgroundColor: '#e3fce3',
              padding: '1rem',
              marginBottom: '1rem',
              borderRadius: '10px'
            }}>
              <h4>{claim.itemName}</h4>
              <p><strong>Claimed by:</strong> {claim.claimedByName || claim.yourName}</p>
              <p><strong>Email:</strong> {claim.studentEmail || claim.userEmail || claim.email || 'Not provided'}</p>
              <p><strong>Description:</strong> {claim.claimedDescription || claim.itemDescription}</p>
              <p><strong>Status:</strong> ✅ Approved</p>
              <button
                onClick={() => handleNotify(claim)}
                style={{
                  marginTop: '0.5rem',
                  backgroundColor: '#1B3B6F',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Notify Owner
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Approved;
